import { HelmetDexteel } from "@dexteel/mesf-core";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

export interface ConfirmationDialogRawProps {
	title: string;
	message?: string;
	open: boolean;
	onClose: (value?: string) => void;
	suffixTitle?: string;
}
export const ConfirmationDialogRaw = ({
	title,
	message,
	open,
	onClose,
	suffixTitle,
	...other
}: ConfirmationDialogRawProps) => {
	const handleCancel = () => {
		onClose("Cancel");
	};
	const handleOk = () => {
		onClose("OK");
	};
	return (
		<>
			{open && (
				<HelmetDexteel
					title={`${title}${suffixTitle ? ` - ${suffixTitle}` : ""}`}
				/>
			)}
			<Dialog maxWidth="xs" open={open} {...other}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent dividers>
					<DialogContentText sx={{ whiteSpace: "pre-line" }}>
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleCancel}>
						Cancel
					</Button>
					<Button onClick={handleOk}>Ok</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
